import React from 'react';
import { Bug, XCircle, AlertTriangle, ShieldAlert } from 'lucide-react';
export function Problem() {
  return <section className="py-16 px-4 bg-slate-900 text-white" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        {/* The Problem */}
        <div className="text-center mb-16" data-id="element-185">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-500/10 rounded-full mb-6" data-id="element-186">
            <Bug className="w-10 h-10 text-red-500" data-id="element-187" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-188">
            En Estados Unidos, el{' '}
            <span className="text-red-500 text-5xl md:text-6xl font-black block my-4" data-id="element-189">
              95%
            </span>{' '}
            de los piojos han mutado en "Súper Piojos"
          </h2>

          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed mb-6" data-id="element-190">
            Son resistentes a los químicos de marcas comunes como Nix o Rid. Por
            eso, aunque bañes a tu hijo en veneno,{' '}
            <strong className="text-white" data-id="element-191">
              las liendres sobreviven dentro de su cápsula blindada.
            </strong>
          </p>

          <div className="bg-slate-800/50 border border-slate-700 p-6 rounded-xl max-w-2xl mx-auto" data-id="element-192">
            <p className="text-lg text-slate-300" data-id="element-193">
              Si matas al adulto pero dejas una sola liendre, esa liendre nacerá
              en 7 días. Y el ciclo de rascado, vergüenza y gasto de dinero en
              la farmacia comenzará de nuevo.
            </p>
            <p className="text-red-400 font-bold mt-4 text-xl" data-id="element-194">
              Estás atrapada en un ciclo de reinfestación constante que le está
              robando la paz a tu familia y tu dinero al bolsillo.
            </p>
          </div>
        </div>

        {/* Why What You Tried Didn't Work */}
        <div className="mt-16" data-id="element-195">
          <h3 className="text-2xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-196">
            <AlertTriangle className="text-amber-400 w-8 h-8" data-id="element-197" />
            Por qué lo que intentaste NO funcionó
          </h3>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-198">
            <div className="bg-slate-800 p-6 rounded-xl border border-slate-700 flex gap-4" data-id="element-199">
              <XCircle className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-200" />
              <div data-id="element-201">
                <h4 className="font-bold text-lg mb-2" data-id="element-202">Fórmulas Obsoletas</h4>
                <p className="text-slate-400 text-sm" data-id="element-203">
                  Los productos de farmacia en USA usan fórmulas de hace 20 años
                  a las que los piojos actuales ya son inmunes. El shampoo no
                  mata la liendre; solo marea al piojo adulto por unas horas.
                </p>
              </div>
            </div>

            <div className="bg-slate-800 p-6 rounded-xl border border-slate-700 flex gap-4" data-id="element-204">
              <XCircle className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-205" />
              <div data-id="element-206">
                <h4 className="font-bold text-lg mb-2" data-id="element-207">
                  Limpieza Compulsiva Inútil
                </h4>
                <p className="text-slate-400 text-sm" data-id="element-208">
                  Lavar toda la casa compulsivamente es agotador e inútil si no
                  cortas el ciclo directamente en la cabeza del niño.
                </p>
              </div>
            </div>

            <div className="bg-slate-800 p-6 rounded-xl border border-slate-700 flex gap-4" data-id="element-209">
              <XCircle className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-210" />
              <div data-id="element-211">
                <h4 className="font-bold text-lg mb-2" data-id="element-212">
                  Herramientas Inadecuadas
                </h4>
                <p className="text-slate-400 text-sm" data-id="element-213">
                  Los peines de plástico que vienen en las cajas son demasiado
                  flexibles y dejan pasar el 40% de los huevos.
                </p>
              </div>
            </div>

            <div className="bg-slate-800 p-6 rounded-xl border border-slate-700 flex gap-4" data-id="element-214">
              <XCircle className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-215" />
              <div data-id="element-216">
                <h4 className="font-bold text-lg mb-2" data-id="element-217">
                  El Mito del "Un Solo Uso"
                </h4>
                <p className="text-slate-400 text-sm" data-id="element-218">
                  Confiar en que "un solo uso" es suficiente ignora por completo
                  el periodo de incubación biológica de 7 a 10 días.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}